import { defineComponent as _defineComponent } from 'vue'
interface Props {
  items?: any[];
  activeSlug?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogCategoriesNav',
  props: {
    items: { default: () => [] },
    activeSlug: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})